import React from "react";
import { useState } from "react";
import cmsImage from "utils/cmsImage";
import detectLang from "utils/detectLang";
import imageUrl from "utils/imageUrl";
import _html from "utils/_html";

const InvestorCard = ({ data, lang }) => {
  const [showMore, setShowMore] = useState(false);
  return (
    <>
      {/* <div className="investor-card">
        <div className="investor-card-img mb-2">
          <div className="investor-card-img-inner">
            <img src={cmsImage(data?.image)} alt="" />
          </div>
        </div>
        <div className="investor-card-body">
          <div className="section-dots">
            <div className="dot dot-1"></div>
            <div className="dot dot-2"></div>
            <div className="dot dot-3"></div>
            <div className="dot dot-4"></div>
            <div className="dot dot-5"></div>
          </div>
          <p className="custom-card-title text-center my-0">{detectLang(data,'name',lang)}</p>
          <p className={`t-card-desc mt-1 mb-0 ${!showMore && "expandable"}`}>
            {_html(detectLang(data,'description',lang))}
          </p>
          <button
            style={{ all: "unset", cursor: "pointer" }}
            onClick={() => {
              setShowMore((prev) => !prev);
            }}
          >
            {showMore ? "Show less" : "Show more"}
          </button>
        </div>
      </div> */}
      <div className="investor-card">
        <div className="investor-card-img">
            <img src={cmsImage(data?.image)} alt="" />
        </div>
        <div className="investor-card-body">
          <img src="/images/bt1.png" alt="" className="bt1"/>
          <p className="investor-title">{detectLang(data, 'name', lang)}</p>
          <p className={`investor-desc ${!showMore && "expandable"}`}>
            {_html(detectLang(data, 'description', lang))}
          </p>
          <img src="/images/bt2.png" alt="" className="bt2"/>
        </div>
      </div>
    </>
  );
};

export default InvestorCard;
